import { useContext, useEffect, useCallback } from 'react';
import { ProductsContext } from './provider';

const useProductsByLocation = (locationId?: number) => {
  const productsContext = useContext(ProductsContext);

  if (!productsContext) {
    throw new Error('useProductsByLocation must be used within a ProductsProvider');
  }

  const { getProductsForLocation, isLoading: checkLoading, hasProduct: hasProductByLocation } = productsContext;

  useEffect(() => {
    if (locationId) getProductsForLocation(locationId);
  }, [locationId, getProductsForLocation]);

  const hasProduct = useCallback(
    (product: string) => hasProductByLocation(product, locationId),
    [hasProductByLocation, locationId]
  );

  return {
    hasProduct,
    isLoading: locationId ? checkLoading(locationId) : false,
  };
};

export default useProductsByLocation;
